import { initialARUniversityEntryRequest } from "../../../../../init/initRequests";
import ARUniEntryRequestForm from "./form/ARUniEntryRequestForm";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  pendingThunkState,
  THUNK_STATUS,
  CircularTextLoader,
  fillNonNullValues,
  useAsyncCall,
  AsyncCallArgs,
  fulfilledThunkState,
  rejectedThunkState,
} from "@duosoftbg/nacid-components";
import { useTranslation } from "react-i18next";
import { Alert } from "@mui/material";
import { getARUniEntryRequest } from "../../../../../axios/api/services";

const ARUniEntryRequestEdit = () => {
  const { t } = useTranslation();
  const { asyncCall } = useAsyncCall();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [form, setForm] = useState(pendingThunkState({}));

  const getData = () => {
    const data = form.data;
    const target = { ...initialARUniversityEntryRequest };
    fillNonNullValues(data, target);
    return target;
  };

  useEffect(() => {
    const asyncGet: AsyncCallArgs = {
      withGlobalBackdrop: false,
      promise: getARUniEntryRequest(id),
      processResponseErrors: false,
      onSuccess: (response) => {
        setForm(fulfilledThunkState(response));
      },
      onError: () => {
        setForm(rejectedThunkState({}));
      },
    };
    asyncCall(asyncGet);
  }, [id, asyncCall]);

  if (form.status === THUNK_STATUS.PENDING) {
    return <CircularTextLoader />;
  } else if (form.status === THUNK_STATUS.REJECTED) {
    return <Alert severity={"error"}>{t("m.generic.error.service.fail")}</Alert>;
  } else if (form.status === THUNK_STATUS.FULFILLED) {
    return <ARUniEntryRequestForm formInitialData={getData()} />;
  } else {
    return null;
  }
};
export default ARUniEntryRequestEdit;
